import {
  GuestJourneyActiveCards,
  GuestJourneyDistributions,
  GuestJourneyStageGrid,
  GuestJourneyMemberTrendsResponse,
  GuestJourneyVioTrend,
} from '../guest-journey-reports.types';
import { buildStageGrid } from './stage-grid.utils';

// Values arrive pre-formatted from the BE (PulseKpiCard); the FE renders them
// verbatim. Titles are BE-supplied and pre-translated.
export const activeCustomersCardsFixture: GuestJourneyActiveCards = {
  newMembers: {
    title: 'New Members',
    value: '49,145',
    trend: { text: 'Trending Up', direction: 'UP' },
  },
  conversionRateToFirstOrder: {
    title: 'Conversion Rate to First Order',
    value: '76.3%',
    trend: { text: 'Above All Time', direction: 'UP' },
  },
  totalMembers: {
    title: 'Total Members',
    value: '403,028',
    trend: { text: 'Trending Up', direction: 'UP' },
  },
  membersWhoOrdered: {
    title: 'Members Who Ordered',
    value: '280,487',
    trend: { text: 'Trending Up', direction: 'UP' },
  },
  totalSlidersSaved: {
    title: 'Total Sliders Saved',
    value: '1,245',
    trend: { text: 'Trending Up', direction: 'UP' },
  },
  totalChurnedSaved: {
    title: 'Total Churned Saved',
    value: '512',
    trend: { text: 'Trending Up', direction: 'UP' },
  },
};

// BE `GuestJourneyInsightDTO[]` — `GET v2/guest-journey/active/insights`.
export const activeCustomersVioTrendsFixture: GuestJourneyVioTrend[] = [
  {
    text: 'Indulgent Superfans grew 14% over the last 90 days, the largest stage gain.',
    movement: { text: 'Moving Up', direction: 'UP_RIGHT' },
  },
  {
    text: 'Core Explorers are sliding — 8% fewer members compared to the prior period.',
    movement: { text: 'Moving Down', direction: 'DOWN_LEFT' },
  },
  {
    text: 'Median days to first order improved from 7 to 5.',
    movement: { text: 'Moving Up', direction: 'UP_RIGHT' },
  },
];

export const activeCustomersGridFixture: GuestJourneyStageGrid = {
  countGrid: buildStageGrid([
    '18,230',
    '14,210',
    '2,410',
    '12,450',
    '26,840',
    '8,120',
    '320',
    '1,820',
    '410',
  ]),
  spendGrid: buildStageGrid([
    '$121,400',
    '$246,100',
    '$86,400',
    '$351,200',
    '$1,102,400',
    '$824,400',
    '$18,450',
    '$142,100',
    '$88,200',
  ]),
  visitsGrid: buildStageGrid([
    '31,420',
    '81,240',
    '49,230',
    '22,310',
    '184,230',
    '162,130',
    '712',
    '9,120',
    '8,120',
  ]),
};

export const activeCustomersDistributionsFixture: GuestJourneyDistributions = {
  spendPie: {
    data: [
      { label: 'Indulgent', value: 2550 },
      { label: 'Core', value: 47410 },
      { label: 'Value', value: 34850 },
    ],
  },
  visitsPie: {
    data: [
      { label: 'Superfan', value: 10940 },
      { label: 'Regular', value: 42870 },
      { label: 'Explorer', value: 31000 },
    ],
  },
  acquisitionSource: {
    xlabels: ['Web', 'Mobile', 'Imported'],
    series: [
      { label: 'Has Ordered', data: [18420, 22340, 8120] },
      { label: 'Has Not Ordered', data: [4210, 5120, 1820] },
    ],
  },
};

export const activeCustomersMemberTrendsFixture: GuestJourneyMemberTrendsResponse =
  {
    xlabels: [
      'Day 1',
      'Day 15',
      'Day 30',
      'Day 45',
      'Day 60',
      'Day 75',
      'Day 90',
    ],
    series: [
      {
        label: 'Indulgent Superfan',
        data: [410, 420, 425, 432, 440, 445, 460],
      },
      {
        label: 'Core Regular',
        data: [25400, 25800, 26100, 26500, 26840, 27000, 27200],
      },
      {
        label: 'Value Explorer',
        data: [18800, 18600, 18400, 18230, 18100, 17900, 17800],
      },
    ],
  };
